import { createStore } from 'react-sweet-state';
const actions = {
  setOrgId: orgId => ({
    setState
  }) => {
    setState({
      orgId
    });
  }
};
const initialState = {
  orgId: undefined
};

/**
 * Manage states of a site
 */
export const Store = createStore({
  initialState,
  actions,
  name: 'Org'
});